module.exports = __webpack_public_path__ + "static/media/intro_wheel_genie.aa7a645c.png";